import React from 'react';
import { SingleLineText } from '@bloomays-lib/ui.shared';
import { styled } from '@mui/material/styles';
import { Logo } from '@bloomays-lib/ui.shared';
import { BloomerStatus } from '@bloomays-lib/types.shared';
import logo from '../../graphic-charter/logos/bloomays_logo.svg';

export type NameTalentProps = {
  name: string;
  statusBloomer?: BloomerStatus;
};

const StyledContainer = styled('div')(
  `
  display: flex;
  align-items: center;
  gap: 8px;
`,
);

const StyledText = styled(SingleLineText)(
  ({ theme }) => `
  color: ${theme.palette.neutral[50]};
`,
);

const StatusLogo = styled(Logo)`
  width: 20px;
  height: 20px;
`;

const Abbr = styled('abbr')`
  display: flex;
  align-items: center;
`;

const NameTalent = ({ name, statusBloomer }: NameTalentProps) => {
  return (
    <StyledContainer>
      <StyledText variant={'body2Medium'} text={name} />
      {statusBloomer && (
        <Abbr title={statusBloomer}>
          <StatusLogo image={logo} alt={statusBloomer} />
        </Abbr>
      )}
    </StyledContainer>
  );
};

export default NameTalent;
export { NameTalent };
